export default __webpack_public_path__ + "static/media/pencil-write.3641e643.svg";